'use es6';

import getIn from 'transmute/getIn';

/**
 * @deprecated use `conversations-internal-schema/responders/operators/responderGetters` instead
 */
export const getAgentType = getIn(['agentType']);